import { Injectable, inject } from '@angular/core';
import { IListDataProvider, MdbService } from '@luzula/luzula-lib';
import { DataService } from '../data.service';

/**
 * Implementierung von IListDataProvider für die App.
 * Verwendet DataService für hardcodierte Daten und MdbService für JSON-Tabellen.
 */
@Injectable({ providedIn: 'root' })
export class ListDataProvider implements IListDataProvider {
	private ds = inject(DataService);
	private mdb = inject(MdbService);

	getHardcoded(tableName: string): any[] {
		return this.ds.getHardcoded(tableName);
	}

	getTable(tableName: string): any[] {
		// Gibt leeres Array zurück wenn Tabelle noch nicht geladen
		// Das Laden wird im Hintergrund getriggert
		return this.mdb.getTable(tableName) ?? [];
	}
}
